import type React from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Actions } from '../../../Flux/Slice/index.js'
import { invitationSlice } from '../../../Flux/Slice/Invitation/InvitationSlice.js'
import { useInvites } from '../../../Flux/Selector/index.js'
import { Box } from '../../Common/index.js'
import { LabInviteNotificationCompact, OrderCompletedNotificationCompact, ProjectInviteCompact } from './CompactInvites.js'

export const InvitesPage: React.FC = () => {
  const dispatch = useDispatch()
  const invites = useInvites()
  const isLoading = invites === 'LOADING'

  useEffect(() => {
    dispatch(Actions[invitationSlice.name].getAllInvitesRequest())
  }, [dispatch])

  if (isLoading) {
    return (
      <div className="bg-slate-100 rounded-lg p-4 drop-shadow-sm m-auto">
        <div className="overflow-y-auto" style={{ minWidth: 900 }}>
          <h1 className="text-2xl mb-4 pl-4">Invitations</h1>
          <hr className="py-2" />
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <Box>
      <div className="overflow-y-auto" style={{ minWidth: 900 }}>
        <h1 className="text-2xl mb-4 pl-4">Invitations</h1>
        <hr className="py-2" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div className="bg-slate-50 p-4 rounded-lg overflow-y-auto">
            <h2 className="text-lg font-semibold mb-2">Received Invitations</h2>
            <div className="space-y-2 max-h-96 overflow-y-auto">
              {!invites ? null : (invites.received?.projectInvites?.length ?? 0) === 0 &&
                (invites.received?.labInvites?.length ?? 0) === 0 &&
                (invites.received?.orderCompletedNotifications?.length ?? 0) === 0 ? (
                <p className="text-gray-500">You have no received invitations.</p>
              ) : (
                <>
                  {invites.received?.projectInvites?.map((x, index) => <ProjectInviteCompact key={index} type="RECEIVE" invite={x} />)}
                  {invites.received?.labInvites?.map((x, index) => <LabInviteNotificationCompact key={index} type="RECEIVE" invite={x} />)}
                  {invites.received?.orderCompletedNotifications?.map((x, index) => (
                    <OrderCompletedNotificationCompact key={index} type="RECEIVE" invite={x} />
                  ))}
                </>
              )}
            </div>
          </div>

          <div className="bg-slate-50 p-4 rounded-lg overflow-y-auto">
            <h2 className="text-lg font-semibold mb-2">Sent Invitations</h2>
            <div className="space-y-2 max-h-96 overflow-y-auto">
              {!invites ? null : (invites.send?.projectInvites?.length ?? 0) === 0 &&
                (invites.send?.labInvites?.length ?? 0) === 0 &&
                (invites.send?.orderCompletedNotifications?.length ?? 0) === 0 ? (
                <p className="text-gray-500">You have no sent invitations.</p>
              ) : (
                <>
                  {invites.send?.projectInvites?.map((x, index) => <ProjectInviteCompact key={index} type="SEND" invite={x} />)}
                  {invites.send?.labInvites?.map((x, index) => <LabInviteNotificationCompact key={index} type="SEND" invite={x} />)}
                  {invites.send?.orderCompletedNotifications?.map((x, index) => (
                    <OrderCompletedNotificationCompact key={index} type="SEND" invite={x} />
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Box>
  )
}
